<div class="container app__component">
    <h1 class="heading">
        <ng-container i18n>Order Types</ng-container>
        <small *ngIf="loading && orderTypes" class="text-muted" i18n>Loading...</small>
    </h1>

    <app-loader *ngIf="!orderTypes" class="text-muted" i18n>Loading...</app-loader>

    <p *ngIf="orderTypes">
        <button class="btn  btn-primary  button--add-to-table" (click)="add()" [disabled]="loading || saving" i18n>Add order Type</button>
    </p>

    <app-table [autoSizeLastColumn]="true" *ngIf="orderTypes">
        <thead>
            <tr>
                <th i18n>Name</th>
                <th style="width: 60px;"></th>
            </tr>
        </thead>

        <tbody [sortablejs]="orderTypes" [sortablejsOptions]="options">
            <ng-template ngFor let-orderType [ngForOf]="orderTypes">
                <tr>
                    <td>
                        <span class="sortablejs--handle  text-muted" [ngStyle]="{ cursor: saving ? 'not-allowed' : 'move' }" style="display: inline-block; width: 10px;">=</span> {{ orderType.name }}
                    </td>
                    <td class="text-right">
                        <button (click)="edit(orderType)" class="btn  btn-sm  btn-primary  mr-2" [disabled]="loading || saving" i18n>Edit</button>
                        <button (click)="delete(orderType)" class="btn  btn-sm  btn-danger" [disabled]="loading || saving" i18n>Delete</button>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </app-table>
</div>
